import { removeFromTaxLinkedList, removeTerminalDefaultTax } from '../forms/form-helpers';
import { configureStore } from '../../store/store';
import { IAuthUser } from '../../models/user.interface';
import { ITax } from '../../models/taxes.interface';
import useAuth from '../../hooks/auth-hooks';

/**
 * Display selected taxes for a terminal/cardgroup
 * 
 * @param {object} linkedTaxes the tax data
 * @param {HTMLElement} parentContainer the html element container to display the list
 */
export const displayTaxes = (linkedTaxes: Array<ITax>, parentContainer: HTMLElement) => {
  if (typeof linkedTaxes != 'object' || linkedTaxes === null) return {};

  const { accessType } = useAuth()!;

  Object.values(linkedTaxes).map((e: any) => {
    let div = document.createElement('div');
    div.className = `double-row-widget aafp_border-radius cg_access_${e.taxId}`;
    div.setAttribute(`data-taxid`, e.taxId);
    div.setAttribute('data-name', e.taxName);
    div.setAttribute('data-rate', e.taxRate);

    let linkTerminal = document.createElement('div');
    linkTerminal.className = 'aafp_link-terminal';
    linkTerminal.style.marginBottom = '0';

    let span = document.createElement('span');
    span.textContent = `Name: ${e.taxName} | Rate: ${e.taxRate}`;
    span.style.fontSize = '1.5rem';

    let i = document.createElement('i');
    i.className = `far fa-trash-alt element-remove-${e.taxId}`;
    i.setAttribute('data-toggle', 'tooltip');
    i.setAttribute('data-placement', 'bottom');
    i.setAttribute('data-id', e.taxId);
    i.setAttribute('title', `Remove ${e.taxName}`);

    linkTerminal.appendChild(span);
    if ( accessType != 'R') {
      linkTerminal.appendChild(i);
    }
    div.appendChild(linkTerminal);
    
    if ( linkedTaxes.length > 1 ) {
      parentContainer.appendChild(div);
    } else {
      parentContainer.prepend(div);
    }
    
    removeFromTaxLinkedList(`.element-remove-${e.taxId}`, e.taxId);
  });

  linkedTaxes.length = 0;
}

/**
 * Display selected default taxes for a terminal
 * 
 * @param {ITax[]} data the tax data
 * @param {HTMLElement} container the html element container to display the list
 */
export const displayDefaultTaxes = (data: ITax[], container: HTMLElement) => {
  const { accessType } = useAuth()!;

  data.forEach((e: ITax) => {
    console.log(e)
    const div = document.createElement('div');
    div.className = `double-row-widget aafp_border-radius cg_access_${e.taxId}`;
    div.setAttribute('data-taxid', e.taxId);
    div.setAttribute('data-name', e.taxName);
    div.setAttribute('data-rate', e.taxRate);

    const linkTerminal = document.createElement('div');
    linkTerminal.className = 'aafp_link-terminal';
    linkTerminal.style.marginBottom = '0';

    const span = document.createElement('span');
    span.textContent = `Name: ${e.taxName} | Rate: ${e.taxRate}`;
    span.style.fontSize = '1.5rem';

    const i = document.createElement('i');
    i.className = `far fa-trash-alt element-remove-${e.taxId}`;
    i.setAttribute('data-toggle', 'tooltip');
    i.setAttribute('data-placement', 'bottom');
    i.setAttribute('data-id', e.taxId);
    i.setAttribute('title', `Remove ${e.taxName}`);

    linkTerminal.appendChild(span);
    if ( accessType != 'R') {
      linkTerminal.appendChild(i);
    }
    div.appendChild(linkTerminal);
    
    if ( data.length > 1 ) {
      container.appendChild(div);
    } else {
      container.prepend(div);
    }
    
    removeTerminalDefaultTax(`.element-remove-${e.taxId}`, e.taxId);
  });

  data.length = 0;
}